import React from 'react';
import DiagramUtils from '../../utils/DiagramUtils';
import DiagramUI from "../DiagramUI";
import Model from "./DiagramViewerModel";
import DiagramViewer from "../../DiagramViewer";

export default class UI extends DiagramUI {

    state = {};

    constructor(props, context) {
        super(props, context);
    }

    componentWillMount() {
        super.componentWillMount();
    }

    dispatchMessage(name, data) {
        if (!this.props.model.dispatchInnerMessages)
            return;

        if (!this.props.model._sys.designer)
            return;

        this.props.model._sys.designer.dispatch(name, data);
    }

    render() {

        const style = this.props.model.toStyle();

        let data = this.props.model.getDefaultData();
        if (!data)
            data = this.props.model.dataContext.data;

        return (
            <div className={"diagram-ui ui-diagram-viewer" + (this.props.className || "")} style={style}  >
                {this.props.model.docId && <DiagramViewer
                    docId={this.props.model.docId}
                    fit={this.props.model.stretchToFit}
                    hscroll={this.props.model.overflowX}
                    vscroll={this.props.model.overflowY}
                    data={data}
                    loadingBackgroundColor={this.props.model.loadingBackgroundColor}
                    messageDispatcher={this.props.model.dispatchInnerMessages ? (name, data) => this.dispatchMessage(name, data) : null}
                    designerRef={ref => this.designer = ref} />
                }
            </div>
        );
    }
}

const type = new Model().getType();
DiagramUtils.register(type, {
    model: Model,
    name: type,
    alias: "大屏文档",
    catalog: "基础",
    svg: "#anticon-ziyuan",
    uiGetter: (model) => <UI model={model} />
});